import type { PaymentMethod } from '../lib/api';

/** Original-color official-source symbols, without a white plate or wordmark. */
export function PaymentIcon({ method }: { method: PaymentMethod }) {
  return <img className="account-payment-icon" src={method === 'wxpay' ? '/images/payments/wechatpay-icon.svg' : '/images/payments/alipay.png'} width={24} height={24} alt="" aria-hidden="true" />;
}
